import { getTag, LANGUAGES, removePrefix } from "@ihr-radioedit/inferno-core";
import { inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import type { Store } from "@inferno/renderer-shared-core";
import { Remote } from "../../components/remote/Remote.component";
import { reverseRoute } from "@inferno/renderer-shared-core";
import { MagicLink } from "../../ui";
import styles from "./CalendarDatasourceMenu.module.scss";

const TOPIC_PREFIX_REGEX = /^[\w-]+\//;

const extractTopic = (memberName: string): string => removePrefix(TOPIC_PREFIX_REGEX)(memberName);

interface CalendarDatasourceMenuProps {
  store?: Store;
  activeCategories?: Set<string>;
}
export const CalendarDatasourceMenu = inject("store")(({ store, activeCategories }: CalendarDatasourceMenuProps) => {
  const { t } = useTranslation();
  if (!store) {
    return null;
  }

  const { site, routeParams, getSdkOpts } = store;

  if (!site.sections.general?.default_event_categories) {
    return null;
  }

  const tags = site.sections.general?.default_event_categories ?? [];
  const allEventsUrl = reverseRoute(site, "calendar_content_all") ?? "";
  const allEventsActiveClass = !routeParams?.topic ? styles.active : "";
  const locale = site.sections.general?.locale?.taxo?.name ?? LANGUAGES.English;

  return (
    <nav className={styles.componentCalendarMenu}>
      <ul>
        {allEventsUrl ? (
          <li>
            <MagicLink to={allEventsUrl} target={"_top"} className={allEventsActiveClass}>
              {t("all_events")}
            </MagicLink>
          </li>
        ) : null}
        {tags
          .filter(tag => {
            if (!tag?.taxo?.displayName || !tag?.taxo?.memberName) {
              return false;
            }
            if (!activeCategories || activeCategories.size === 0) {
              return true;
            }
            const topic = extractTopic(tag.taxo.memberName);
            return activeCategories.has(topic);
          })
          .map(tag => {
            const memberName = tag.taxo?.memberName ?? "";
            const topic = extractTopic(memberName);
            const activeClass = topic === routeParams?.topic ? styles.active : "";
            const url = reverseRoute(site, "calendar_content_category", { topic });

            if (!url) {
              return null;
            }

            return (
              <li key={`category-${topic}`}>
                <Remote
                  loader={() => getTag(memberName, locale, getSdkOpts())}
                  cacheKey={`calendar-category-${topic}-${locale.toLowerCase()}`}
                >
                  {({ data }) =>
                    data ? (
                      <MagicLink to={url} target={"_top"} className={activeClass}>
                        {data.displayName}
                      </MagicLink>
                    ) : null
                  }
                </Remote>
              </li>
            );
          })}
      </ul>
    </nav>
  );
});
